
	function AdditionalResourcesPopup(settings){
		this.className = "AdditionalResourcesPopup";

		this.name = "additional-resources";

    if(!settings) settings = {};

		this.data = {
			pages: [
				{
					title: "Additional Resources List",
          name: "select-resource",
          static: true,
					onRender: (e) => {

					}
				},
				
			]
		}
		this.setup(settings);
	};
  AdditionalResourcesPopup.inheritsFrom( PopupForm );